/**
 * Bridges the kit's descriptor-derived resources into refine.
 *
 * `getAiPortalResources` (compiled from the kit's descriptors + coreBOS view map) is the
 * single source of truth for what entities exist and how their views are ordered. Here it
 * is bound to the `default` (CQRS) provider and reshaped into refine `ResourceProps`.
 * A kit extends the portal by adding a descriptor — no page code required.
 */

import type { ResourceProps } from "@refinedev/core";
import { getAiPortalResources, type RefineResource } from "@kit/refine-resources";

export const kitResources: RefineResource[] = getAiPortalResources({
  dataProviderName: "default",
});

export const resourceBySlug: Record<string, RefineResource> = Object.fromEntries(
  kitResources.map((r) => [r.name, r])
);

export const refineResources: ResourceProps[] = kitResources.map((r) => ({
  name: r.name,
  list: r.list,
  show: r.show,
  create: r.create,
  edit: r.edit,
  meta: {
    label: r.meta.label,
    dataProviderName: r.meta.dataProviderName,
    canDelete: true,
  },
}));
